<template>
    <div class="tenant-services">
      <h1>Tenant Services</h1>
      <div v-if="services.length">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="service in services" :key="service.id">
              <td>{{ service.name }}</td>
              <td>{{ service.description }}</td>
              <td>{{ service.status }}</td>
              <td>
                <router-link :to="{ name: 'service.details', params: { id: service.id } }" class="btn btn-primary">
                  Manage
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <p>No services available.</p>
      </div>
    </div>
  </template>

  <script>
  import axios from 'axios';

  export default {
    name: 'TenantServicesIndex',
    data() {
      return {
        services: []
      };
    },
    created() {
      this.fetchServices();
    },
    methods: {
      async fetchServices() {
        try {
          const response = await axios.get('/api/services');
          this.services = response.data;
        } catch (error) {
          console.error('Error fetching services:', error);
        }
      }
    }
  };
  </script>

  <style scoped>
  .tenant-services {
    padding: 20px;
  }

  .table {
    width: 100%;
    border-collapse: collapse;
  }

  .table th, .table td {
    padding: 10px;
    text-align: left;
    border: 1px solid #ddd;
  }

  .table th {
    background-color: #f4f4f4;
  }

  .btn-primary {
    color: #fff;
    background-color: #007bff;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    text-decoration: none;
  }

  .btn-primary:hover {
    background-color: #0056b3;
  }
  </style>
